import { Media, WorkspaceRoutine, Addon } from '@gripp/shared-logic';
import { RoutineOrder } from '../../assets/domain/workspaceAsset';

export interface Product {
  id: string;
  name: string;
  description?: string;
  details?: string;
  specifications?: string;
  coverImage?: Media;
  addons?: Addon[];
  routines?: WorkspaceRoutine[];
  routineOrder?: RoutineOrder[];
  media?: Media[];
}
